/** 通話エラー variant の列挙定数 */
export const CALL_ERROR_VARIANT = {
  CONNECTION_FAILED: "connectionFailed",
  BILLING_FAILED: "billingFailed",
  FETCH_FAILED: "fetchFailed",
  VIDEO_TIMEOUT: "videoTimeout",
  CHANNEL_ENDED: "channelEnded",
} as const;

/** 通話エラー variant の型 */
export type CallErrorVariant =
  (typeof CALL_ERROR_VARIANT)[keyof typeof CALL_ERROR_VARIANT];

/** Sentry 送信スコープの列挙定数 */
export const CALL_ERROR_SCOPE_VALUE = {
  SESSION: "session",
  GENERIC: "generic",
  SILENT: "silent",
} as const;

/** Sentry 送信スコープの型 */
export type CallErrorScope =
  (typeof CALL_ERROR_SCOPE_VALUE)[keyof typeof CALL_ERROR_SCOPE_VALUE];

/**
 * 通話エラー variant ごとの Sentry 送信スコープ。
 * - session: 通話セッション中のエラー。captureCallError で通話コンテキスト付きで送信する
 * - generic: セッション確立前のエラー。captureError で汎用送信する
 * - silent: エラーではない通知（配信終了等）。Sentry には送信しない
 *
 * 表示文言は i18n（locales/ja.json の callError.messages.<variant>）で管理する。
 */
export const CALL_ERROR_SCOPE = {
  connectionFailed: CALL_ERROR_SCOPE_VALUE.SESSION,
  billingFailed: CALL_ERROR_SCOPE_VALUE.SESSION,
  videoTimeout: CALL_ERROR_SCOPE_VALUE.SESSION,
  fetchFailed: CALL_ERROR_SCOPE_VALUE.GENERIC,
  channelEnded: CALL_ERROR_SCOPE_VALUE.SILENT,
} as const satisfies Record<CallErrorVariant, CallErrorScope>;

/** 通話種別の列挙定数 */
export const CALL_TYPE = {
  LIVE: "live",
  VIDEO: "video",
  VOICE: "voice",
} as const;

/** 通話種別の型 */
export type CallType = (typeof CALL_TYPE)[keyof typeof CALL_TYPE];
